module.exports = __webpack_public_path__ + "img/smapa.f749db3d.jpg";